import { Injectable } from '@angular/core';
import { OperatorFindInterface } from '@zaoblako/shared/modules/finance/dtos/operator/operator-find.dto';
import { OperatorPageInterface } from '@zaoblako/shared/modules/finance/dtos/operator/operator-page.dto';
import { OperatorQueryInterface } from '@zaoblako/shared/modules/finance/dtos/operator/operator-query.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OperatorService extends BaseService {
  protected baseUrl = '/fdo/operator';

  public findWithPagination(queryParams: OperatorQueryInterface): Observable<OperatorPageInterface> {
    return this.http.get<OperatorPageInterface>(this.baseUrl, { params: this.objectToHttpParams(queryParams) });
  }

  public findFlat(): Observable<OperatorFindInterface[]> {
    return this.http.get<OperatorFindInterface[]>(`${this.baseUrl}/list`);
  }
}
